module.exports = __webpack_public_path__ + "static/media/MHRP09N0010.782f69b6.svg";